"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AIDocumentImporterMessage () {
        return AIDocumentImporterMessage;
    },
    get AIDocumentImporterTrigger () {
        return AIDocumentImporterTrigger;
    }
});
const _zod = require("zod");
const AIDocumentImporterTrigger = _zod.z.enum([
    "competency"
]);
const AIDocumentImporterMessage = _zod.z.object({
    trigger: AIDocumentImporterTrigger,
    companyId: _zod.z.string(),
    userId: _zod.z.string(),
    s3Key: _zod.z.string(),
    taskId: _zod.z.string()
});
